module.exports = __webpack_public_path__ + "static/media/Starter.9f552f03.svg";